import { InvoiceType } from "../../GeneratedClients/FreeBillApi"

const isInvoiceWithoutTax = (invoiceType?: InvoiceType, isSmallBusiness?: boolean) => {
  return  isSmallBusiness ||
          invoiceType === InvoiceType.EuInvoiceService ||
          invoiceType === InvoiceType.EuInvoiceDelivery ||
          invoiceType === InvoiceType.ThirdCountryInvoiceService ||
          invoiceType === InvoiceType.ThirdCountryInvoiceDelivery ||
          invoiceType === InvoiceType.Revenues13bInvoice
}

export default isInvoiceWithoutTax